<template>
  <div class="content">
    <h1>Skema</h1>
    <img :src="path" alt="skema" />
    <!-- this is a test -->
  </div>
</template>

<script>
export default {
  name: "Skema",
  computed: {
    path() {
      let v = "";
      if (this.$route.params.version) {
        v = `_${this.$route.params.version}`;
      }
      return `/static/images/CC_SKEMA${v}.svg`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/undervisning/skema.vue